import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { useRecoilValue } from "recoil";
import { orderSheetFilterState } from "@/shared/store/orderSheetFilterStore";

const highlightText = (text: string, searchText: string) => {
  if (!searchText) return text;
  const reg = new RegExp(`(${searchText})`, "gi");

  return text.replace(
    reg,
    "<span class='bg-interactive-selected-active'>$1</span>"
  );
};

const HtmlCellRenderer = ({ value }: ICellRendererParams) => {
  const globalSearchValue = useRecoilValue(orderSheetFilterState);
  if (!value || typeof value !== "string") {
    return <span>{value}</span>;
  }

  const highlightedContent = highlightText(value, globalSearchValue);

  return <span dangerouslySetInnerHTML={{ __html: highlightedContent }} />;
};

export default HtmlCellRenderer;
